import { createModel } from '@rematch/core';
import type { RootModel } from '.';
import { PaginationFactory } from '../factory';
import { UserTypes } from '../types/user.types';

export interface UserStoreProps {
    user: UserTypes.Model;
    pagination: PaginationFactory<UserTypes.Model>;
    loading: {
        fetchMany: boolean;
        fetchAll: boolean;
    };
    modal: {
        details: boolean;
    };
    allUsers: UserTypes.Model[];
}

export const userInitialState = {
    user: {} as UserTypes.Model,
    pagination: {} as PaginationFactory<UserTypes.Model>,
    loading: {
        fetchMany: false,
        fetchAll: false,
    },
    modal: {
        details: false,
    },
    allUsers: [] as UserTypes.Model[],
};

export const user = createModel<RootModel>()({
    state: userInitialState,
    reducers: {
        boot: (store) => {
            store = userInitialState;
        },
        setUser: (store, user: UserTypes.Model) => {
            store.user = user;
        },
        toggleLoading: (
            store,
            prop: keyof UserStoreProps['loading'],
            v: boolean
        ) => {
            store.loading[prop] = v;
        },
        toggleModal: (
            store,
            prop: keyof UserStoreProps['modal'],
            v: boolean
        ) => {
            if (!store.modal) {
                store.modal = userInitialState.modal;
            }

            if (
                typeof store.modal[prop] !== 'boolean' ||
                store.modal[prop] === undefined
            ) {
                store.modal = {
                    ...store.modal,
                    [prop]: v,
                };
            }

            store.modal[prop] = v;
        },
        setPagination: (
            store,
            pagination: PaginationFactory<UserTypes.Model>
        ) => {
            store.pagination = pagination;
        },
        removePaginationItem: (store, userId: string) => {
            store.pagination.items = store.pagination.items.filter(
                (u) => u.id !== userId
            );
        },
        setAllUsers: (store, users: UserTypes.Model[]) => {
            store.allUsers = users;
        },
    },
});
